export enum RecurringInvoicesRoute {
  List = '/',
  ListEmpty = '/empty',
}
